import { memo } from "react";
import Link from "@mui/material/Link";
import type { LinkProps } from "@mui/material/Link";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { styled } from "../../../../lib/styled";

const ExternalLinkRoot = styled(Link)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  overflow: "hidden",
  color: theme.palette.text.secondary,
}));

const ExternalLinkIcon = styled(OpenInNewIcon)({
  flexShrink: 0,
  fontSize: "1em",
});

const ExternalLinkText = styled("span")({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export type ExternalLinkProps = Omit<LinkProps, "target" | "rel">;

/** External anchor link: OpenInNew icon prefix, truncated text, text.secondary color.
 *  Pass `variant` to control the Typography scale; use `sx` or `maxWidth` to size it. */
export const ExternalLink = memo(function ExternalLink({ children, ...props }: ExternalLinkProps) {
  return (
    <ExternalLinkRoot target="_blank" rel="noopener noreferrer" {...props}>
      <ExternalLinkIcon />
      <ExternalLinkText>{children}</ExternalLinkText>
    </ExternalLinkRoot>
  );
});
